'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var icons__AbandonedCartMajor_svg = require('./icons/AbandonedCartMajor.svg.js');
var icons__AccessibilityMajor_svg = require('./icons/AccessibilityMajor.svg.js');
var icons__ActivitiesMajor_svg = require('./icons/ActivitiesMajor.svg.js');
var icons__AddCodeMajor_svg = require('./icons/AddCodeMajor.svg.js');
var icons__AddImageMajor_svg = require('./icons/AddImageMajor.svg.js');
var icons__AddMajor_svg = require('./icons/AddMajor.svg.js');
var icons__AddNoteMajor_svg = require('./icons/AddNoteMajor.svg.js');
var icons__AddProductMajor_svg = require('./icons/AddProductMajor.svg.js');
var icons__AdjustMinor_svg = require('./icons/AdjustMinor.svg.js');
var icons__AffiliateMajor_svg = require('./icons/AffiliateMajor.svg.js');
var icons__AlertMinor_svg = require('./icons/AlertMinor.svg.js');
var icons__AnalyticsBarHorizontalMinor_svg = require('./icons/AnalyticsBarHorizontalMinor.svg.js');
var icons__AnalyticsBarStackedMinor_svg = require('./icons/AnalyticsBarStackedMinor.svg.js');
var icons__AnalyticsCohortMinor_svg = require('./icons/AnalyticsCohortMinor.svg.js');
var icons__AnalyticsDonutMinor_svg = require('./icons/AnalyticsDonutMinor.svg.js');
var icons__AnalyticsFunnelMinor_svg = require('./icons/AnalyticsFunnelMinor.svg.js');
var icons__AnalyticsLineMinor_svg = require('./icons/AnalyticsLineMinor.svg.js');
var icons__AnalyticsMajor_svg = require('./icons/AnalyticsMajor.svg.js');
var icons__AnalyticsMinor_svg = require('./icons/AnalyticsMinor.svg.js');
var icons__AnalyticsTableMinor_svg = require('./icons/AnalyticsTableMinor.svg.js');
var icons__AnyClickModelMinor_svg = require('./icons/AnyClickModelMinor.svg.js');
var icons__AppExtensionMinor_svg = require('./icons/AppExtensionMinor.svg.js');
var icons__AppsMajor_svg = require('./icons/AppsMajor.svg.js');
var icons__AppsMinor_svg = require('./icons/AppsMinor.svg.js');
var icons__ArchiveMajor_svg = require('./icons/ArchiveMajor.svg.js');
var icons__ArchiveMinor_svg = require('./icons/ArchiveMinor.svg.js');
var icons__ArrowDownMinor_svg = require('./icons/ArrowDownMinor.svg.js');
var icons__ArrowLeftMinor_svg = require('./icons/ArrowLeftMinor.svg.js');
var icons__ArrowRightMinor_svg = require('./icons/ArrowRightMinor.svg.js');
var icons__ArrowUpMinor_svg = require('./icons/ArrowUpMinor.svg.js');
var icons__AttachmentMajor_svg = require('./icons/AttachmentMajor.svg.js');
var icons__AutomationMajor_svg = require('./icons/AutomationMajor.svg.js');
var icons__BackspaceMajor_svg = require('./icons/BackspaceMajor.svg.js');
var icons__BalanceMajor_svg = require('./icons/BalanceMajor.svg.js');
var icons__BankMajor_svg = require('./icons/BankMajor.svg.js');
var icons__BarcodeMajor_svg = require('./icons/BarcodeMajor.svg.js');
var icons__BehaviorMajor_svg = require('./icons/BehaviorMajor.svg.js');
var icons__BehaviorMinor_svg = require('./icons/BehaviorMinor.svg.js');
var icons__BillingStatementDollarMajor_svg = require('./icons/BillingStatementDollarMajor.svg.js');
var icons__BillingStatementEuroMajor_svg = require('./icons/BillingStatementEuroMajor.svg.js');
var icons__BillingStatementPoundMajor_svg = require('./icons/BillingStatementPoundMajor.svg.js');
var icons__BillingStatementRupeeMajor_svg = require('./icons/BillingStatementRupeeMajor.svg.js');
var icons__BillingStatementYenMajor_svg = require('./icons/BillingStatementYenMajor.svg.js');
var icons__BlockMinor_svg = require('./icons/BlockMinor.svg.js');
var icons__BlockquoteMajor_svg = require('./icons/BlockquoteMajor.svg.js');
var icons__BlogMajor_svg = require('./icons/BlogMajor.svg.js');
var icons__BugMajor_svg = require('./icons/BugMajor.svg.js');
var icons__ButtonCornerPillMajor_svg = require('./icons/ButtonCornerPillMajor.svg.js');
var icons__ButtonCornerRoundedMajor_svg = require('./icons/ButtonCornerRoundedMajor.svg.js');
var icons__ButtonCornerSquareMajor_svg = require('./icons/ButtonCornerSquareMajor.svg.js');
var icons__ButtonMinor_svg = require('./icons/ButtonMinor.svg.js');
var icons__BuyButtonButtonLayoutMajor_svg = require('./icons/BuyButtonButtonLayoutMajor.svg.js');
var icons__BuyButtonHorizontalLayoutMajor_svg = require('./icons/BuyButtonHorizontalLayoutMajor.svg.js');
var icons__BuyButtonMajor_svg = require('./icons/BuyButtonMajor.svg.js');
var icons__BuyButtonVerticalLayoutMajor_svg = require('./icons/BuyButtonVerticalLayoutMajor.svg.js');
var icons__CalendarMajor_svg = require('./icons/CalendarMajor.svg.js');
var icons__CalendarMinor_svg = require('./icons/CalendarMinor.svg.js');
var icons__CalendarTickMajor_svg = require('./icons/CalendarTickMajor.svg.js');
var icons__CalendarTimeMinor_svg = require('./icons/CalendarTimeMinor.svg.js');
var icons__CameraMajor_svg = require('./icons/CameraMajor.svg.js');
var icons__CancelMajor_svg = require('./icons/CancelMajor.svg.js');
var icons__CancelMinor_svg = require('./icons/CancelMinor.svg.js');
var icons__CancelSmallMinor_svg = require('./icons/CancelSmallMinor.svg.js');
var icons__CapitalMajor_svg = require('./icons/CapitalMajor.svg.js');
var icons__CapturePaymentMinor_svg = require('./icons/CapturePaymentMinor.svg.js');
var icons__CardReaderChipMajor_svg = require('./icons/CardReaderChipMajor.svg.js');
var icons__CardReaderMajor_svg = require('./icons/CardReaderMajor.svg.js');
var icons__CardReaderTapMajor_svg = require('./icons/CardReaderTapMajor.svg.js');
var icons__CaretDownMinor_svg = require('./icons/CaretDownMinor.svg.js');
var icons__CaretUpMinor_svg = require('./icons/CaretUpMinor.svg.js');
var icons__CartDownMajor_svg = require('./icons/CartDownMajor.svg.js');
var icons__CartMajor_svg = require('./icons/CartMajor.svg.js');
var icons__CartUpMajor_svg = require('./icons/CartUpMajor.svg.js');
var icons__CashDollarMajor_svg = require('./icons/CashDollarMajor.svg.js');
var icons__CashDollarMinor_svg = require('./icons/CashDollarMinor.svg.js');
var icons__CashEuroMajor_svg = require('./icons/CashEuroMajor.svg.js');
var icons__CashPoundMajor_svg = require('./icons/CashPoundMajor.svg.js');
var icons__CashRupeeMajor_svg = require('./icons/CashRupeeMajor.svg.js');
var icons__CashYenMajor_svg = require('./icons/CashYenMajor.svg.js');
var icons__CategoriesMajor_svg = require('./icons/CategoriesMajor.svg.js');
var icons__ChannelsMajor_svg = require('./icons/ChannelsMajor.svg.js');
var icons__ChatMajor_svg = require('./icons/ChatMajor.svg.js');
var icons__ChecklistAlternateMajor_svg = require('./icons/ChecklistAlternateMajor.svg.js');
var icons__ChecklistMajor_svg = require('./icons/ChecklistMajor.svg.js');
var icons__CheckoutMajor_svg = require('./icons/CheckoutMajor.svg.js');
var icons__ChevronDownMinor_svg = require('./icons/ChevronDownMinor.svg.js');
var icons__ChevronLeftMinor_svg = require('./icons/ChevronLeftMinor.svg.js');
var icons__ChevronRightMinor_svg = require('./icons/ChevronRightMinor.svg.js');
var icons__ChevronUpMinor_svg = require('./icons/ChevronUpMinor.svg.js');
var icons__CircleAlertMajor_svg = require('./icons/CircleAlertMajor.svg.js');
var icons__CircleCancelMajor_svg = require('./icons/CircleCancelMajor.svg.js');
var icons__CircleCancelMinor_svg = require('./icons/CircleCancelMinor.svg.js');
var icons__CircleChevronDownMinor_svg = require('./icons/CircleChevronDownMinor.svg.js');
var icons__CircleChevronLeftMinor_svg = require('./icons/CircleChevronLeftMinor.svg.js');
var icons__CircleChevronRightMinor_svg = require('./icons/CircleChevronRightMinor.svg.js');
var icons__CircleChevronUpMinor_svg = require('./icons/CircleChevronUpMinor.svg.js');
var icons__CircleDisableMinor_svg = require('./icons/CircleDisableMinor.svg.js');
var icons__CircleDisabledMajor_svg = require('./icons/CircleDisabledMajor.svg.js');
var icons__CircleDotsMajor_svg = require('./icons/CircleDotsMajor.svg.js');
var icons__CircleDownMajor_svg = require('./icons/CircleDownMajor.svg.js');
var icons__CircleInformationMajor_svg = require('./icons/CircleInformationMajor.svg.js');
var icons__CircleLeftMajor_svg = require('./icons/CircleLeftMajor.svg.js');
var icons__CircleMinusMajor_svg = require('./icons/CircleMinusMajor.svg.js');
var icons__CircleMinusMinor_svg = require('./icons/CircleMinusMinor.svg.js');
var icons__CircleMinusOutlineMinor_svg = require('./icons/CircleMinusOutlineMinor.svg.js');
var icons__CirclePlusMajor_svg = require('./icons/CirclePlusMajor.svg.js');
var icons__CirclePlusMinor_svg = require('./icons/CirclePlusMinor.svg.js');
var icons__CirclePlusOutlineMinor_svg = require('./icons/CirclePlusOutlineMinor.svg.js');
var icons__CircleRightMajor_svg = require('./icons/CircleRightMajor.svg.js');
var icons__CircleTickMajor_svg = require('./icons/CircleTickMajor.svg.js');
var icons__CircleTickMinor_svg = require('./icons/CircleTickMinor.svg.js');
var icons__CircleTickOutlineMinor_svg = require('./icons/CircleTickOutlineMinor.svg.js');
var icons__CircleUpMajor_svg = require('./icons/CircleUpMajor.svg.js');
var icons__ClipboardMinor_svg = require('./icons/ClipboardMinor.svg.js');
var icons__ClockMajor_svg = require('./icons/ClockMajor.svg.js');
var icons__ClockMinor_svg = require('./icons/ClockMinor.svg.js');
var icons__CodeMajor_svg = require('./icons/CodeMajor.svg.js');
var icons__CodeMinor_svg = require('./icons/CodeMinor.svg.js');
var icons__CollectionReferenceMinor_svg = require('./icons/CollectionReferenceMinor.svg.js');
var icons__CollectionsMajor_svg = require('./icons/CollectionsMajor.svg.js');
var icons__ColorNoneMinor_svg = require('./icons/ColorNoneMinor.svg.js');
var icons__ColorsMajor_svg = require('./icons/ColorsMajor.svg.js');
var icons__Column1Major_svg = require('./icons/Column1Major.svg.js');
var icons__ColumnWithTextMajor_svg = require('./icons/ColumnWithTextMajor.svg.js');
var icons__Columns2Major_svg = require('./icons/Columns2Major.svg.js');
var icons__Columns3Major_svg = require('./icons/Columns3Major.svg.js');
var icons__Columns3Minor_svg = require('./icons/Columns3Minor.svg.js');
var icons__ComposeMajor_svg = require('./icons/ComposeMajor.svg.js');
var icons__ConfettiMajor_svg = require('./icons/ConfettiMajor.svg.js');
var icons__ConnectMinor_svg = require('./icons/ConnectMinor.svg.js');
var icons__ContentMinor_svg = require('./icons/ContentMinor.svg.js');
var icons__ConversationMinor_svg = require('./icons/ConversationMinor.svg.js');
var icons__CreditCardCancelMajor_svg = require('./icons/CreditCardCancelMajor.svg.js');
var icons__CreditCardMajor_svg = require('./icons/CreditCardMajor.svg.js');
var icons__CreditCardPercentMajor_svg = require('./icons/CreditCardPercentMajor.svg.js');
var icons__CreditCardSecureMajor_svg = require('./icons/CreditCardSecureMajor.svg.js');
var icons__CurrencyConvertMinor_svg = require('./icons/CurrencyConvertMinor.svg.js');
var icons__CustomerMinusMajor_svg = require('./icons/CustomerMinusMajor.svg.js');
var icons__CustomerPlusMajor_svg = require('./icons/CustomerPlusMajor.svg.js');
var icons__CustomersMajor_svg = require('./icons/CustomersMajor.svg.js');
var icons__CustomersMinor_svg = require('./icons/CustomersMinor.svg.js');
var icons__DataDrivenModelMinor_svg = require('./icons/DataDrivenModelMinor.svg.js');
var icons__DataVisualizationMajor_svg = require('./icons/DataVisualizationMajor.svg.js');
var icons__DecimalMinor_svg = require('./icons/DecimalMinor.svg.js');
var icons__DeleteMajor_svg = require('./icons/DeleteMajor.svg.js');
var icons__DeleteMinor_svg = require('./icons/DeleteMinor.svg.js');
var icons__DesktopMajor_svg = require('./icons/DesktopMajor.svg.js');
var icons__DetailedPopUpMajor_svg = require('./icons/DetailedPopUpMajor.svg.js');
var icons__DiamondAlertMajor_svg = require('./icons/DiamondAlertMajor.svg.js');
var icons__DiamondAlertMinor_svg = require('./icons/DiamondAlertMinor.svg.js');
var icons__DigitalMediaReceiverMajor_svg = require('./icons/DigitalMediaReceiverMajor.svg.js');
var icons__DiscountAutomaticMajor_svg = require('./icons/DiscountAutomaticMajor.svg.js');
var icons__DiscountCodeMajor_svg = require('./icons/DiscountCodeMajor.svg.js');
var icons__DiscountsMajor_svg = require('./icons/DiscountsMajor.svg.js');
var icons__DiscountsMinor_svg = require('./icons/DiscountsMinor.svg.js');
var icons__DisputeMinor_svg = require('./icons/DisputeMinor.svg.js');
var icons__DnsSettingsMajor_svg = require('./icons/DnsSettingsMajor.svg.js');
var icons__DockFloatingMajor_svg = require('./icons/DockFloatingMajor.svg.js');
var icons__DockSideMajor_svg = require('./icons/DockSideMajor.svg.js');
var icons__DomainNewMajor_svg = require('./icons/DomainNewMajor.svg.js');
var icons__DomainRedirectMinor_svg = require('./icons/DomainRedirectMinor.svg.js');
var icons__DomainsMajor_svg = require('./icons/DomainsMajor.svg.js');
var icons__DraftOrdersMajor_svg = require('./icons/DraftOrdersMajor.svg.js');
var icons__DragDropMajor_svg = require('./icons/DragDropMajor.svg.js');
var icons__DragHandleMinor_svg = require('./icons/DragHandleMinor.svg.js');
var icons__DropdownMinor_svg = require('./icons/DropdownMinor.svg.js');
var icons__DuplicateMinor_svg = require('./icons/DuplicateMinor.svg.js');
var icons__DynamicSourceMajor_svg = require('./icons/DynamicSourceMajor.svg.js');
var icons__DynamicSourceMinor_svg = require('./icons/DynamicSourceMinor.svg.js');
var icons__EditMajor_svg = require('./icons/EditMajor.svg.js');
var icons__EditMinor_svg = require('./icons/EditMinor.svg.js');
var icons__EmailMajor_svg = require('./icons/EmailMajor.svg.js');
var icons__EmailNewsletterMajor_svg = require('./icons/EmailNewsletterMajor.svg.js');
var icons__EmbedMinor_svg = require('./icons/EmbedMinor.svg.js');
var icons__EnableSelectionMinor_svg = require('./icons/EnableSelectionMinor.svg.js');
var icons__EnterMajor_svg = require('./icons/EnterMajor.svg.js');
var icons__EnvelopeMajor_svg = require('./icons/EnvelopeMajor.svg.js');
var icons__ExchangeMajor_svg = require('./icons/ExchangeMajor.svg.js');
var icons__ExistingInventoryMajor_svg = require('./icons/ExistingInventoryMajor.svg.js');
var icons__ExitMajor_svg = require('./icons/ExitMajor.svg.js');
var icons__ExploreImagesMajor_svg = require('./icons/ExploreImagesMajor.svg.js');
var icons__ExportMinor_svg = require('./icons/ExportMinor.svg.js');
var icons__ExtendMajor_svg = require('./icons/ExtendMajor.svg.js');
var icons__ExtendMinor_svg = require('./icons/ExtendMinor.svg.js');
var icons__ExternalMinor_svg = require('./icons/ExternalMinor.svg.js');
var icons__ExternalSmallMinor_svg = require('./icons/ExternalSmallMinor.svg.js');
var icons__EyeDropperMinor_svg = require('./icons/EyeDropperMinor.svg.js');
var icons__FaviconMajor_svg = require('./icons/FaviconMajor.svg.js');
var icons__FavoriteMajor_svg = require('./icons/FavoriteMajor.svg.js');
var icons__FeaturedCollectionMajor_svg = require('./icons/FeaturedCollectionMajor.svg.js');
var icons__FeaturedContentMajor_svg = require('./icons/FeaturedContentMajor.svg.js');
var icons__FileMinor_svg = require('./icons/FileMinor.svg.js');
var icons__FilterMajor_svg = require('./icons/FilterMajor.svg.js');
var icons__FilterMinor_svg = require('./icons/FilterMinor.svg.js');
var icons__FinancesMajor_svg = require('./icons/FinancesMajor.svg.js');
var icons__FinancesMinor_svg = require('./icons/FinancesMinor.svg.js');
var icons__FirstClickModelMinor_svg = require('./icons/FirstClickModelMinor.svg.js');
var icons__FirstOrderMajor_svg = require('./icons/FirstOrderMajor.svg.js');
var icons__FirstVisitMajor_svg = require('./icons/FirstVisitMajor.svg.js');
var icons__FlagMajor_svg = require('./icons/FlagMajor.svg.js');
var icons__FlipCameraMajor_svg = require('./icons/FlipCameraMajor.svg.js');
var icons__FolderDownMajor_svg = require('./icons/FolderDownMajor.svg.js');
var icons__FolderMajor_svg = require('./icons/FolderMajor.svg.js');
var icons__FolderMinusMajor_svg = require('./icons/FolderMinusMajor.svg.js');
var icons__FolderPlusMajor_svg = require('./icons/FolderPlusMajor.svg.js');
var icons__FolderUpMajor_svg = require('./icons/FolderUpMajor.svg.js');
var icons__FollowUpEmailMajor_svg = require('./icons/FollowUpEmailMajor.svg.js');
var icons__FoodMajor_svg = require('./icons/FoodMajor.svg.js');
var icons__FooterMajor_svg = require('./icons/FooterMajor.svg.js');
var icons__FormsMajor_svg = require('./icons/FormsMajor.svg.js');
var icons__FraudProtectMajor_svg = require('./icons/FraudProtectMajor.svg.js');
var icons__FraudProtectMinor_svg = require('./icons/FraudProtectMinor.svg.js');
var icons__FraudProtectPendingMajor_svg = require('./icons/FraudProtectPendingMajor.svg.js');
var icons__FraudProtectPendingMinor_svg = require('./icons/FraudProtectPendingMinor.svg.js');
var icons__FraudProtectUnprotectedMajor_svg = require('./icons/FraudProtectUnprotectedMajor.svg.js');
var icons__FraudProtectUnprotectedMinor_svg = require('./icons/FraudProtectUnprotectedMinor.svg.js');
var icons__FulfillmentFulfilledMajor_svg = require('./icons/FulfillmentFulfilledMajor.svg.js');
var icons__FulfillmentOnHoldMajor_svg = require('./icons/FulfillmentOnHoldMajor.svg.js');
var icons__GamesConsoleMajor_svg = require('./icons/GamesConsoleMajor.svg.js');
var icons__GiftCardMajor_svg = require('./icons/GiftCardMajor.svg.js');
var icons__GiftCardMinor_svg = require('./icons/GiftCardMinor.svg.js');
var icons__GlobeMajor_svg = require('./icons/GlobeMajor.svg.js');
var icons__GlobeMinor_svg = require('./icons/GlobeMinor.svg.js');
var icons__GrammarMajor_svg = require('./icons/GrammarMajor.svg.js');
var icons__HashtagMajor_svg = require('./icons/HashtagMajor.svg.js');
var icons__HashtagMinor_svg = require('./icons/HashtagMinor.svg.js');
var icons__HeaderMajor_svg = require('./icons/HeaderMajor.svg.js');
var icons__HeartMajor_svg = require('./icons/HeartMajor.svg.js');
var icons__HideKeyboardMajor_svg = require('./icons/HideKeyboardMajor.svg.js');
var icons__HideMinor_svg = require('./icons/HideMinor.svg.js');
var icons__HintMajor_svg = require('./icons/HintMajor.svg.js');
var icons__HomeMajor_svg = require('./icons/HomeMajor.svg.js');
var icons__HomeMinor_svg = require('./icons/HomeMinor.svg.js');
var icons__HorizontalDotsMinor_svg = require('./icons/HorizontalDotsMinor.svg.js');
var icons__IconsMajor_svg = require('./icons/IconsMajor.svg.js');
var icons__IdentityCardMajor_svg = require('./icons/IdentityCardMajor.svg.js');
var icons__IllustrationMajor_svg = require('./icons/IllustrationMajor.svg.js');
var icons__ImageAltMajor_svg = require('./icons/ImageAltMajor.svg.js');
var icons__ImageAltMinor_svg = require('./icons/ImageAltMinor.svg.js');
var icons__ImageMajor_svg = require('./icons/ImageMajor.svg.js');
var icons__ImageWithTextMajor_svg = require('./icons/ImageWithTextMajor.svg.js');
var icons__ImageWithTextOverlayMajor_svg = require('./icons/ImageWithTextOverlayMajor.svg.js');
var icons__ImagesMajor_svg = require('./icons/ImagesMajor.svg.js');
var icons__ImportMinor_svg = require('./icons/ImportMinor.svg.js');
var icons__ImportStoreMajor_svg = require('./icons/ImportStoreMajor.svg.js');
var icons__InactiveLocationMajor_svg = require('./icons/InactiveLocationMajor.svg.js');
var icons__InactiveLocationMinor_svg = require('./icons/InactiveLocationMinor.svg.js');
var icons__IncomingMajor_svg = require('./icons/IncomingMajor.svg.js');
var icons__InfoMinor_svg = require('./icons/InfoMinor.svg.js');
var icons__InsertDynamicSourceMajor_svg = require('./icons/InsertDynamicSourceMajor.svg.js');
var icons__InsertDynamicSourceMinor_svg = require('./icons/InsertDynamicSourceMinor.svg.js');
var icons__InstallMinor_svg = require('./icons/InstallMinor.svg.js');
var icons__InventoryMajor_svg = require('./icons/InventoryMajor.svg.js');
var icons__InviteMinor_svg = require('./icons/InviteMinor.svg.js');
var icons__IqMajor_svg = require('./icons/IqMajor.svg.js');
var icons__JobsMajor_svg = require('./icons/JobsMajor.svg.js');
var icons__KeyMajor_svg = require('./icons/KeyMajor.svg.js');
var icons__KeyboardMajor_svg = require('./icons/KeyboardMajor.svg.js');
var icons__KeyboardMinor_svg = require('./icons/KeyboardMinor.svg.js');
var icons__LabelPrinterMajor_svg = require('./icons/LabelPrinterMajor.svg.js');
var icons__LandingPageMajor_svg = require('./icons/LandingPageMajor.svg.js');
var icons__LanguageMinor_svg = require('./icons/LanguageMinor.svg.js');
var icons__LastClickModelMinor_svg = require('./icons/LastClickModelMinor.svg.js');
var icons__LastNonDirectClickModelMinor_svg = require('./icons/LastNonDirectClickModelMinor.svg.js');
var icons__LegalMajor_svg = require('./icons/LegalMajor.svg.js');
var icons__LinearModelMinor_svg = require('./icons/LinearModelMinor.svg.js');
var icons__LinkMinor_svg = require('./icons/LinkMinor.svg.js');
var icons__ListMajor_svg = require('./icons/ListMajor.svg.js');
var icons__ListMinor_svg = require('./icons/ListMinor.svg.js');
var icons__LiveViewMajor_svg = require('./icons/LiveViewMajor.svg.js');
var icons__LocationMajor_svg = require('./icons/LocationMajor.svg.js');
var icons__LocationsMinor_svg = require('./icons/LocationsMinor.svg.js');
var icons__LockMajor_svg = require('./icons/LockMajor.svg.js');
var icons__LockMinor_svg = require('./icons/LockMinor.svg.js');
var icons__LogOutMinor_svg = require('./icons/LogOutMinor.svg.js');
var icons__LogoBlockMajor_svg = require('./icons/LogoBlockMajor.svg.js');
var icons__MagicMajor_svg = require('./icons/MagicMajor.svg.js');
var icons__MagicMinor_svg = require('./icons/MagicMinor.svg.js');
var icons__ManagedStoreMajor_svg = require('./icons/ManagedStoreMajor.svg.js');
var icons__MarkFulfilledMinor_svg = require('./icons/MarkFulfilledMinor.svg.js');
var icons__MarkPaidMinor_svg = require('./icons/MarkPaidMinor.svg.js');
var icons__MarketingMajor_svg = require('./icons/MarketingMajor.svg.js');
var icons__MarketingMinor_svg = require('./icons/MarketingMinor.svg.js');
var icons__MarketsMajor_svg = require('./icons/MarketsMajor.svg.js');
var icons__MaximizeMajor_svg = require('./icons/MaximizeMajor.svg.js');
var icons__MaximizeMinor_svg = require('./icons/MaximizeMinor.svg.js');
var icons__MeasurementMinor_svg = require('./icons/MeasurementMinor.svg.js');
var icons__MentionMajor_svg = require('./icons/MentionMajor.svg.js');
var icons__MergeMinor_svg = require('./icons/MergeMinor.svg.js');
var icons__MetafieldsMajor_svg = require('./icons/MetafieldsMajor.svg.js');
var icons__MetafieldsMinor_svg = require('./icons/MetafieldsMinor.svg.js');
var icons__MetaobjectMinor_svg = require('./icons/MetaobjectMinor.svg.js');
var icons__MetaobjectReferenceMinor_svg = require('./icons/MetaobjectReferenceMinor.svg.js');
var icons__MicrophoneMajor_svg = require('./icons/MicrophoneMajor.svg.js');
var icons__MinimizeMajor_svg = require('./icons/MinimizeMajor.svg.js');
var icons__MinimizeMinor_svg = require('./icons/MinimizeMinor.svg.js');
var icons__MinusMajor_svg = require('./icons/MinusMajor.svg.js');
var icons__MinusMinor_svg = require('./icons/MinusMinor.svg.js');
var icons__MobileAcceptMajor_svg = require('./icons/MobileAcceptMajor.svg.js');
var icons__MobileBackArrowMajor_svg = require('./icons/MobileBackArrowMajor.svg.js');
var icons__MobileCancelMajor_svg = require('./icons/MobileCancelMajor.svg.js');
var icons__MobileChevronMajor_svg = require('./icons/MobileChevronMajor.svg.js');
var icons__MobileHamburgerMajor_svg = require('./icons/MobileHamburgerMajor.svg.js');
var icons__MobileHorizontalDotsMajor_svg = require('./icons/MobileHorizontalDotsMajor.svg.js');
var icons__MobileMajor_svg = require('./icons/MobileMajor.svg.js');
var icons__MobilePlusMajor_svg = require('./icons/MobilePlusMajor.svg.js');
var icons__MobileVerticalDotsMajor_svg = require('./icons/MobileVerticalDotsMajor.svg.js');
var icons__MonerisMajor_svg = require('./icons/MonerisMajor.svg.js');
var icons__MoneyMinor_svg = require('./icons/MoneyMinor.svg.js');
var icons__NatureMajor_svg = require('./icons/NatureMajor.svg.js');
var icons__NavigationMajor_svg = require('./icons/NavigationMajor.svg.js');
var icons__NoteMajor_svg = require('./icons/NoteMajor.svg.js');
var icons__NoteMinor_svg = require('./icons/NoteMinor.svg.js');
var icons__NotificationMajor_svg = require('./icons/NotificationMajor.svg.js');
var icons__OnlineStoreMajor_svg = require('./icons/OnlineStoreMajor.svg.js');
var icons__OnlineStoreMinor_svg = require('./icons/OnlineStoreMinor.svg.js');
var icons__OrderStatusMinor_svg = require('./icons/OrderStatusMinor.svg.js');
var icons__OrdersMajor_svg = require('./icons/OrdersMajor.svg.js');
var icons__OrdersMinor_svg = require('./icons/OrdersMinor.svg.js');
var icons__OrganizationMajor_svg = require('./icons/OrganizationMajor.svg.js');
var icons__OutgoingMajor_svg = require('./icons/OutgoingMajor.svg.js');
var icons__PackageMajor_svg = require('./icons/PackageMajor.svg.js');
var icons__PageDownMajor_svg = require('./icons/PageDownMajor.svg.js');
var icons__PageMajor_svg = require('./icons/PageMajor.svg.js');
var icons__PageMinusMajor_svg = require('./icons/PageMinusMajor.svg.js');
var icons__PagePlusMajor_svg = require('./icons/PagePlusMajor.svg.js');
var icons__PageReferenceMinor_svg = require('./icons/PageReferenceMinor.svg.js');
var icons__PageUpMajor_svg = require('./icons/PageUpMajor.svg.js');
var icons__PaginationEndMinor_svg = require('./icons/PaginationEndMinor.svg.js');
var icons__PaginationStartMinor_svg = require('./icons/PaginationStartMinor.svg.js');
var icons__PaintBrushMajor_svg = require('./icons/PaintBrushMajor.svg.js');
var icons__PaperCheckMajor_svg = require('./icons/PaperCheckMajor.svg.js');
var icons__PaperCheckMinor_svg = require('./icons/PaperCheckMinor.svg.js');
var icons__PasskeyMajor_svg = require('./icons/PasskeyMajor.svg.js');
var icons__PasskeyMinor_svg = require('./icons/PasskeyMinor.svg.js');
var icons__PauseCircleMajor_svg = require('./icons/PauseCircleMajor.svg.js');
var icons__PauseMajor_svg = require('./icons/PauseMajor.svg.js');
var icons__PauseMinor_svg = require('./icons/PauseMinor.svg.js');
var icons__PaymentsMajor_svg = require('./icons/PaymentsMajor.svg.js');
var icons__PersonalizedTextMajor_svg = require('./icons/PersonalizedTextMajor.svg.js');
var icons__PhoneInMajor_svg = require('./icons/PhoneInMajor.svg.js');
var icons__PhoneMajor_svg = require('./icons/PhoneMajor.svg.js');
var icons__PhoneOutMajor_svg = require('./icons/PhoneOutMajor.svg.js');
var icons__PinMajor_svg = require('./icons/PinMajor.svg.js');
var icons__PinMinor_svg = require('./icons/PinMinor.svg.js');
var icons__PinUnfilledMajor_svg = require('./icons/PinUnfilledMajor.svg.js');
var icons__PinUnfilledMinor_svg = require('./icons/PinUnfilledMinor.svg.js');
var icons__PlanMajor_svg = require('./icons/PlanMajor.svg.js');
var icons__PlanMinor_svg = require('./icons/PlanMinor.svg.js');
var icons__PlayCircleMajor_svg = require('./icons/PlayCircleMajor.svg.js');
var icons__PlayMajor_svg = require('./icons/PlayMajor.svg.js');
var icons__PlayMinor_svg = require('./icons/PlayMinor.svg.js');
var icons__PlusMinor_svg = require('./icons/PlusMinor.svg.js');
var icons__PointOfSaleMajor_svg = require('./icons/PointOfSaleMajor.svg.js');
var icons__PopularMajor_svg = require('./icons/PopularMajor.svg.js');
var icons__PositionBasedModelMinor_svg = require('./icons/PositionBasedModelMinor.svg.js');
var icons__PriceLookupMinor_svg = require('./icons/PriceLookupMinor.svg.js');
var icons__PrintMajor_svg = require('./icons/PrintMajor.svg.js');
var icons__PrintMinor_svg = require('./icons/PrintMinor.svg.js');
var icons__ProductCostMajor_svg = require('./icons/ProductCostMajor.svg.js');
var icons__ProductReferenceMinor_svg = require('./icons/ProductReferenceMinor.svg.js');
var icons__ProductReturnsMinor_svg = require('./icons/ProductReturnsMinor.svg.js');
var icons__ProductsMajor_svg = require('./icons/ProductsMajor.svg.js');
var icons__ProductsMinor_svg = require('./icons/ProductsMinor.svg.js');
var icons__ProfileMajor_svg = require('./icons/ProfileMajor.svg.js');
var icons__ProfileMinor_svg = require('./icons/ProfileMinor.svg.js');
var icons__PromoteMinor_svg = require('./icons/PromoteMinor.svg.js');
var icons__QuestionMarkInverseMajor_svg = require('./icons/QuestionMarkInverseMajor.svg.js');
var icons__QuestionMarkInverseMinor_svg = require('./icons/QuestionMarkInverseMinor.svg.js');
var icons__QuestionMarkMajor_svg = require('./icons/QuestionMarkMajor.svg.js');
var icons__QuestionMarkMinor_svg = require('./icons/QuestionMarkMinor.svg.js');
var icons__QuickSaleMajor_svg = require('./icons/QuickSaleMajor.svg.js');
var icons__ReadTimeMinor_svg = require('./icons/ReadTimeMinor.svg.js');
var icons__ReceiptMajor_svg = require('./icons/ReceiptMajor.svg.js');
var icons__RecentSearchesMajor_svg = require('./icons/RecentSearchesMajor.svg.js');
var icons__RedoMajor_svg = require('./icons/RedoMajor.svg.js');
var icons__ReferralCodeMajor_svg = require('./icons/ReferralCodeMajor.svg.js');
var icons__ReferralMajor_svg = require('./icons/ReferralMajor.svg.js');
var icons__RefreshMajor_svg = require('./icons/RefreshMajor.svg.js');
var icons__RefreshMinor_svg = require('./icons/RefreshMinor.svg.js');
var icons__RefundMajor_svg = require('./icons/RefundMajor.svg.js');
var icons__RefundMinor_svg = require('./icons/RefundMinor.svg.js');
var icons__RemoveProductMajor_svg = require('./icons/RemoveProductMajor.svg.js');
var icons__RepeatOrderMajor_svg = require('./icons/RepeatOrderMajor.svg.js');
var icons__ReplaceMajor_svg = require('./icons/ReplaceMajor.svg.js');
var icons__ReplayMinor_svg = require('./icons/ReplayMinor.svg.js');
var icons__ReportMinor_svg = require('./icons/ReportMinor.svg.js');
var icons__ReportsMajor_svg = require('./icons/ReportsMajor.svg.js');
var icons__ResetMinor_svg = require('./icons/ResetMinor.svg.js');
var icons__ResourcesMajor_svg = require('./icons/ResourcesMajor.svg.js');
var icons__ReturnMinor_svg = require('./icons/ReturnMinor.svg.js');
var icons__ReturnsMajor_svg = require('./icons/ReturnsMajor.svg.js');
var icons__RichTextMinor_svg = require('./icons/RichTextMinor.svg.js');
var icons__RiskMajor_svg = require('./icons/RiskMajor.svg.js');
var icons__RiskMinor_svg = require('./icons/RiskMinor.svg.js');
var icons__Rows2Major_svg = require('./icons/Rows2Major.svg.js');
var icons__SandboxMajor_svg = require('./icons/SandboxMajor.svg.js');
var icons__SaveMinor_svg = require('./icons/SaveMinor.svg.js');
var icons__SearchMajor_svg = require('./icons/SearchMajor.svg.js');
var icons__SearchMinor_svg = require('./icons/SearchMinor.svg.js');
var icons__SectionMajor_svg = require('./icons/SectionMajor.svg.js');
var icons__SecureMajor_svg = require('./icons/SecureMajor.svg.js');
var icons__SelectMinor_svg = require('./icons/SelectMinor.svg.js');
var icons__SendMajor_svg = require('./icons/SendMajor.svg.js');
var icons__SettingsMajor_svg = require('./icons/SettingsMajor.svg.js');
var icons__SettingsMinor_svg = require('./icons/SettingsMinor.svg.js');
var icons__ShareIosMinor_svg = require('./icons/ShareIosMinor.svg.js');
var icons__ShareMinor_svg = require('./icons/ShareMinor.svg.js');
var icons__ShipmentMajor_svg = require('./icons/ShipmentMajor.svg.js');
var icons__ShopcodesMajor_svg = require('./icons/ShopcodesMajor.svg.js');
var icons__SidebarLeftMajor_svg = require('./icons/SidebarLeftMajor.svg.js');
var icons__SidebarRightMajor_svg = require('./icons/SidebarRightMajor.svg.js');
var icons__SimplifyMajor_svg = require('./icons/SimplifyMajor.svg.js');
var icons__SimplifyMinor_svg = require('./icons/SimplifyMinor.svg.js');
var icons__SlideshowMajor_svg = require('./icons/SlideshowMajor.svg.js');
var icons__SmileyHappyMajor_svg = require('./icons/SmileyHappyMajor.svg.js');
var icons__SmileyJoyMajor_svg = require('./icons/SmileyJoyMajor.svg.js');
var icons__SmileyNeutralMajor_svg = require('./icons/SmileyNeutralMajor.svg.js');
var icons__SmileySadMajor_svg = require('./icons/SmileySadMajor.svg.js');
var icons__SocialAdMajor_svg = require('./icons/SocialAdMajor.svg.js');
var icons__SocialPostMajor_svg = require('./icons/SocialPostMajor.svg.js');
var icons__SoftPackMajor_svg = require('./icons/SoftPackMajor.svg.js');
var icons__SortAscendingMajor_svg = require('./icons/SortAscendingMajor.svg.js');
var icons__SortDescendingMajor_svg = require('./icons/SortDescendingMajor.svg.js');
var icons__SortMinor_svg = require('./icons/SortMinor.svg.js');
var icons__SoundMajor_svg = require('./icons/SoundMajor.svg.js');
var icons__StarFilledMinor_svg = require('./icons/StarFilledMinor.svg.js');
var icons__StarOutlineMinor_svg = require('./icons/StarOutlineMinor.svg.js');
var icons__StatusActiveMajor_svg = require('./icons/StatusActiveMajor.svg.js');
var icons__StoreMajor_svg = require('./icons/StoreMajor.svg.js');
var icons__StoreMinor_svg = require('./icons/StoreMinor.svg.js');
var icons__StoreStatusMajor_svg = require('./icons/StoreStatusMajor.svg.js');
var icons__TabletMajor_svg = require('./icons/TabletMajor.svg.js');
var icons__TapChipMajor_svg = require('./icons/TapChipMajor.svg.js');
var icons__TaxMajor_svg = require('./icons/TaxMajor.svg.js');
var icons__TeamMajor_svg = require('./icons/TeamMajor.svg.js');
var icons__TemplateMajor_svg = require('./icons/TemplateMajor.svg.js');
var icons__TemplateMinor_svg = require('./icons/TemplateMinor.svg.js');
var icons__TextAlignmentCenterMajor_svg = require('./icons/TextAlignmentCenterMajor.svg.js');
var icons__TextAlignmentLeftMajor_svg = require('./icons/TextAlignmentLeftMajor.svg.js');
var icons__TextAlignmentRightMajor_svg = require('./icons/TextAlignmentRightMajor.svg.js');
var icons__TextBlockMajor_svg = require('./icons/TextBlockMajor.svg.js');
var icons__TextMajor_svg = require('./icons/TextMajor.svg.js');
var icons__ThemeEditMajor_svg = require('./icons/ThemeEditMajor.svg.js');
var icons__ThemeStoreMajor_svg = require('./icons/ThemeStoreMajor.svg.js');
var icons__ThemesMajor_svg = require('./icons/ThemesMajor.svg.js');
var icons__ThumbsDownMajor_svg = require('./icons/ThumbsDownMajor.svg.js');
var icons__ThumbsDownMinor_svg = require('./icons/ThumbsDownMinor.svg.js');
var icons__ThumbsUpMajor_svg = require('./icons/ThumbsUpMajor.svg.js');
var icons__ThumbsUpMinor_svg = require('./icons/ThumbsUpMinor.svg.js');
var icons__TickMinor_svg = require('./icons/TickMinor.svg.js');
var icons__TickSmallMinor_svg = require('./icons/TickSmallMinor.svg.js');
var icons__TimeDecayModelMinor_svg = require('./icons/TimeDecayModelMinor.svg.js');
var icons__TimelineAttachmentMajor_svg = require('./icons/TimelineAttachmentMajor.svg.js');
var icons__TipsMajor_svg = require('./icons/TipsMajor.svg.js');
var icons__TitleMinor_svg = require('./icons/TitleMinor.svg.js');
var icons__ToggleMinor_svg = require('./icons/ToggleMinor.svg.js');
var icons__ToolsMajor_svg = require('./icons/ToolsMajor.svg.js');
var icons__TransactionFeeDollarMajor_svg = require('./icons/TransactionFeeDollarMajor.svg.js');
var icons__TransactionFeeEuroMajor_svg = require('./icons/TransactionFeeEuroMajor.svg.js');
var icons__TransactionFeePoundMajor_svg = require('./icons/TransactionFeePoundMajor.svg.js');
var icons__TransactionFeeRupeeMajor_svg = require('./icons/TransactionFeeRupeeMajor.svg.js');
var icons__TransactionFeeYenMajor_svg = require('./icons/TransactionFeeYenMajor.svg.js');
var icons__TransactionMajor_svg = require('./icons/TransactionMajor.svg.js');
var icons__TransferInMajor_svg = require('./icons/TransferInMajor.svg.js');
var icons__TransferMajor_svg = require('./icons/TransferMajor.svg.js');
var icons__TransferOutMajor_svg = require('./icons/TransferOutMajor.svg.js');
var icons__TransferWithinShopifyMajor_svg = require('./icons/TransferWithinShopifyMajor.svg.js');
var icons__TransportMajor_svg = require('./icons/TransportMajor.svg.js');
var icons__TroubleshootMajor_svg = require('./icons/TroubleshootMajor.svg.js');
var icons__TypeMajor_svg = require('./icons/TypeMajor.svg.js');
var icons__TypeMinor_svg = require('./icons/TypeMinor.svg.js');
var icons__UndoMajor_svg = require('./icons/UndoMajor.svg.js');
var icons__UnfulfilledMajor_svg = require('./icons/UnfulfilledMajor.svg.js');
var icons__UnknownDeviceMajor_svg = require('./icons/UnknownDeviceMajor.svg.js');
var icons__UpdateInventoryMajor_svg = require('./icons/UpdateInventoryMajor.svg.js');
var icons__UploadMajor_svg = require('./icons/UploadMajor.svg.js');
var icons__VariantMajor_svg = require('./icons/VariantMajor.svg.js');
var icons__ViewMajor_svg = require('./icons/ViewMajor.svg.js');
var icons__ViewMinor_svg = require('./icons/ViewMinor.svg.js');
var icons__ViewportNarrowMajor_svg = require('./icons/ViewportNarrowMajor.svg.js');
var icons__ViewportShortMajor_svg = require('./icons/ViewportShortMajor.svg.js');
var icons__ViewportTallMajor_svg = require('./icons/ViewportTallMajor.svg.js');
var icons__ViewportWideMajor_svg = require('./icons/ViewportWideMajor.svg.js');
var icons__VocabularyMajor_svg = require('./icons/VocabularyMajor.svg.js');
var icons__VolumeMinor_svg = require('./icons/VolumeMinor.svg.js');
var icons__WandMajor_svg = require('./icons/WandMajor.svg.js');
var icons__WandMinor_svg = require('./icons/WandMinor.svg.js');
var icons__WearableMajor_svg = require('./icons/WearableMajor.svg.js');
var icons__WeightMinor_svg = require('./icons/WeightMinor.svg.js');
var icons__WholesaleMajor_svg = require('./icons/WholesaleMajor.svg.js');
var icons__WifiMajor_svg = require('./icons/WifiMajor.svg.js');
require('react');



exports.AbandonedCartMajor = icons__AbandonedCartMajor_svg.SvgAbandonedCartMajor;
exports.AccessibilityMajor = icons__AccessibilityMajor_svg.SvgAccessibilityMajor;
exports.ActivitiesMajor = icons__ActivitiesMajor_svg.SvgActivitiesMajor;
exports.AddCodeMajor = icons__AddCodeMajor_svg.SvgAddCodeMajor;
exports.AddImageMajor = icons__AddImageMajor_svg.SvgAddImageMajor;
exports.AddMajor = icons__AddMajor_svg.SvgAddMajor;
exports.AddNoteMajor = icons__AddNoteMajor_svg.SvgAddNoteMajor;
exports.AddProductMajor = icons__AddProductMajor_svg.SvgAddProductMajor;
exports.AdjustMinor = icons__AdjustMinor_svg.SvgAdjustMinor;
exports.AffiliateMajor = icons__AffiliateMajor_svg.SvgAffiliateMajor;
exports.AlertMinor = icons__AlertMinor_svg.SvgAlertMinor;
exports.AnalyticsBarHorizontalMinor = icons__AnalyticsBarHorizontalMinor_svg.SvgAnalyticsBarHorizontalMinor;
exports.AnalyticsBarStackedMinor = icons__AnalyticsBarStackedMinor_svg.SvgAnalyticsBarStackedMinor;
exports.AnalyticsCohortMinor = icons__AnalyticsCohortMinor_svg.SvgAnalyticsCohortMinor;
exports.AnalyticsDonutMinor = icons__AnalyticsDonutMinor_svg.SvgAnalyticsDonutMinor;
exports.AnalyticsFunnelMinor = icons__AnalyticsFunnelMinor_svg.SvgAnalyticsFunnelMinor;
exports.AnalyticsLineMinor = icons__AnalyticsLineMinor_svg.SvgAnalyticsLineMinor;
exports.AnalyticsMajor = icons__AnalyticsMajor_svg.SvgAnalyticsMajor;
exports.AnalyticsMinor = icons__AnalyticsMinor_svg.SvgAnalyticsMinor;
exports.AnalyticsTableMinor = icons__AnalyticsTableMinor_svg.SvgAnalyticsTableMinor;
exports.AnyClickModelMinor = icons__AnyClickModelMinor_svg.SvgAnyClickModelMinor;
exports.AppExtensionMinor = icons__AppExtensionMinor_svg.SvgAppExtensionMinor;
exports.AppsMajor = icons__AppsMajor_svg.SvgAppsMajor;
exports.AppsMinor = icons__AppsMinor_svg.SvgAppsMinor;
exports.ArchiveMajor = icons__ArchiveMajor_svg.SvgArchiveMajor;
exports.ArchiveMinor = icons__ArchiveMinor_svg.SvgArchiveMinor;
exports.ArrowDownMinor = icons__ArrowDownMinor_svg.SvgArrowDownMinor;
exports.ArrowLeftMinor = icons__ArrowLeftMinor_svg.SvgArrowLeftMinor;
exports.ArrowRightMinor = icons__ArrowRightMinor_svg.SvgArrowRightMinor;
exports.ArrowUpMinor = icons__ArrowUpMinor_svg.SvgArrowUpMinor;
exports.AttachmentMajor = icons__AttachmentMajor_svg.SvgAttachmentMajor;
exports.AutomationMajor = icons__AutomationMajor_svg.SvgAutomationMajor;
exports.BackspaceMajor = icons__BackspaceMajor_svg.SvgBackspaceMajor;
exports.BalanceMajor = icons__BalanceMajor_svg.SvgBalanceMajor;
exports.BankMajor = icons__BankMajor_svg.SvgBankMajor;
exports.BarcodeMajor = icons__BarcodeMajor_svg.SvgBarcodeMajor;
exports.BehaviorMajor = icons__BehaviorMajor_svg.SvgBehaviorMajor;
exports.BehaviorMinor = icons__BehaviorMinor_svg.SvgBehaviorMinor;
exports.BillingStatementDollarMajor = icons__BillingStatementDollarMajor_svg.SvgBillingStatementDollarMajor;
exports.BillingStatementEuroMajor = icons__BillingStatementEuroMajor_svg.SvgBillingStatementEuroMajor;
exports.BillingStatementPoundMajor = icons__BillingStatementPoundMajor_svg.SvgBillingStatementPoundMajor;
exports.BillingStatementRupeeMajor = icons__BillingStatementRupeeMajor_svg.SvgBillingStatementRupeeMajor;
exports.BillingStatementYenMajor = icons__BillingStatementYenMajor_svg.SvgBillingStatementYenMajor;
exports.BlockMinor = icons__BlockMinor_svg.SvgBlockMinor;
exports.BlockquoteMajor = icons__BlockquoteMajor_svg.SvgBlockquoteMajor;
exports.BlogMajor = icons__BlogMajor_svg.SvgBlogMajor;
exports.BugMajor = icons__BugMajor_svg.SvgBugMajor;
exports.ButtonCornerPillMajor = icons__ButtonCornerPillMajor_svg.SvgButtonCornerPillMajor;
exports.ButtonCornerRoundedMajor = icons__ButtonCornerRoundedMajor_svg.SvgButtonCornerRoundedMajor;
exports.ButtonCornerSquareMajor = icons__ButtonCornerSquareMajor_svg.SvgButtonCornerSquareMajor;
exports.ButtonMinor = icons__ButtonMinor_svg.SvgButtonMinor;
exports.BuyButtonButtonLayoutMajor = icons__BuyButtonButtonLayoutMajor_svg.SvgBuyButtonButtonLayoutMajor;
exports.BuyButtonHorizontalLayoutMajor = icons__BuyButtonHorizontalLayoutMajor_svg.SvgBuyButtonHorizontalLayoutMajor;
exports.BuyButtonMajor = icons__BuyButtonMajor_svg.SvgBuyButtonMajor;
exports.BuyButtonVerticalLayoutMajor = icons__BuyButtonVerticalLayoutMajor_svg.SvgBuyButtonVerticalLayoutMajor;
exports.CalendarMajor = icons__CalendarMajor_svg.SvgCalendarMajor;
exports.CalendarMinor = icons__CalendarMinor_svg.SvgCalendarMinor;
exports.CalendarTickMajor = icons__CalendarTickMajor_svg.SvgCalendarTickMajor;
exports.CalendarTimeMinor = icons__CalendarTimeMinor_svg.SvgCalendarTimeMinor;
exports.CameraMajor = icons__CameraMajor_svg.SvgCameraMajor;
exports.CancelMajor = icons__CancelMajor_svg.SvgCancelMajor;
exports.CancelMinor = icons__CancelMinor_svg.SvgCancelMinor;
exports.CancelSmallMinor = icons__CancelSmallMinor_svg.SvgCancelSmallMinor;
exports.CapitalMajor = icons__CapitalMajor_svg.SvgCapitalMajor;
exports.CapturePaymentMinor = icons__CapturePaymentMinor_svg.SvgCapturePaymentMinor;
exports.CardReaderChipMajor = icons__CardReaderChipMajor_svg.SvgCardReaderChipMajor;
exports.CardReaderMajor = icons__CardReaderMajor_svg.SvgCardReaderMajor;
exports.CardReaderTapMajor = icons__CardReaderTapMajor_svg.SvgCardReaderTapMajor;
exports.CaretDownMinor = icons__CaretDownMinor_svg.SvgCaretDownMinor;
exports.CaretUpMinor = icons__CaretUpMinor_svg.SvgCaretUpMinor;
exports.CartDownMajor = icons__CartDownMajor_svg.SvgCartDownMajor;
exports.CartMajor = icons__CartMajor_svg.SvgCartMajor;
exports.CartUpMajor = icons__CartUpMajor_svg.SvgCartUpMajor;
exports.CashDollarMajor = icons__CashDollarMajor_svg.SvgCashDollarMajor;
exports.CashDollarMinor = icons__CashDollarMinor_svg.SvgCashDollarMinor;
exports.CashEuroMajor = icons__CashEuroMajor_svg.SvgCashEuroMajor;
exports.CashPoundMajor = icons__CashPoundMajor_svg.SvgCashPoundMajor;
exports.CashRupeeMajor = icons__CashRupeeMajor_svg.SvgCashRupeeMajor;
exports.CashYenMajor = icons__CashYenMajor_svg.SvgCashYenMajor;
exports.CategoriesMajor = icons__CategoriesMajor_svg.SvgCategoriesMajor;
exports.ChannelsMajor = icons__ChannelsMajor_svg.SvgChannelsMajor;
exports.ChatMajor = icons__ChatMajor_svg.SvgChatMajor;
exports.ChecklistAlternateMajor = icons__ChecklistAlternateMajor_svg.SvgChecklistAlternateMajor;
exports.ChecklistMajor = icons__ChecklistMajor_svg.SvgChecklistMajor;
exports.CheckoutMajor = icons__CheckoutMajor_svg.SvgCheckoutMajor;
exports.ChevronDownMinor = icons__ChevronDownMinor_svg.SvgChevronDownMinor;
exports.ChevronLeftMinor = icons__ChevronLeftMinor_svg.SvgChevronLeftMinor;
exports.ChevronRightMinor = icons__ChevronRightMinor_svg.SvgChevronRightMinor;
exports.ChevronUpMinor = icons__ChevronUpMinor_svg.SvgChevronUpMinor;
exports.CircleAlertMajor = icons__CircleAlertMajor_svg.SvgCircleAlertMajor;
exports.CircleCancelMajor = icons__CircleCancelMajor_svg.SvgCircleCancelMajor;
exports.CircleCancelMinor = icons__CircleCancelMinor_svg.SvgCircleCancelMinor;
exports.CircleChevronDownMinor = icons__CircleChevronDownMinor_svg.SvgCircleChevronDownMinor;
exports.CircleChevronLeftMinor = icons__CircleChevronLeftMinor_svg.SvgCircleChevronLeftMinor;
exports.CircleChevronRightMinor = icons__CircleChevronRightMinor_svg.SvgCircleChevronRightMinor;
exports.CircleChevronUpMinor = icons__CircleChevronUpMinor_svg.SvgCircleChevronUpMinor;
exports.CircleDisableMinor = icons__CircleDisableMinor_svg.SvgCircleDisableMinor;
exports.CircleDisabledMajor = icons__CircleDisabledMajor_svg.SvgCircleDisabledMajor;
exports.CircleDotsMajor = icons__CircleDotsMajor_svg.SvgCircleDotsMajor;
exports.CircleDownMajor = icons__CircleDownMajor_svg.SvgCircleDownMajor;
exports.CircleInformationMajor = icons__CircleInformationMajor_svg.SvgCircleInformationMajor;
exports.CircleLeftMajor = icons__CircleLeftMajor_svg.SvgCircleLeftMajor;
exports.CircleMinusMajor = icons__CircleMinusMajor_svg.SvgCircleMinusMajor;
exports.CircleMinusMinor = icons__CircleMinusMinor_svg.SvgCircleMinusMinor;
exports.CircleMinusOutlineMinor = icons__CircleMinusOutlineMinor_svg.SvgCircleMinusOutlineMinor;
exports.CirclePlusMajor = icons__CirclePlusMajor_svg.SvgCirclePlusMajor;
exports.CirclePlusMinor = icons__CirclePlusMinor_svg.SvgCirclePlusMinor;
exports.CirclePlusOutlineMinor = icons__CirclePlusOutlineMinor_svg.SvgCirclePlusOutlineMinor;
exports.CircleRightMajor = icons__CircleRightMajor_svg.SvgCircleRightMajor;
exports.CircleTickMajor = icons__CircleTickMajor_svg.SvgCircleTickMajor;
exports.CircleTickMinor = icons__CircleTickMinor_svg.SvgCircleTickMinor;
exports.CircleTickOutlineMinor = icons__CircleTickOutlineMinor_svg.SvgCircleTickOutlineMinor;
exports.CircleUpMajor = icons__CircleUpMajor_svg.SvgCircleUpMajor;
exports.ClipboardMinor = icons__ClipboardMinor_svg.SvgClipboardMinor;
exports.ClockMajor = icons__ClockMajor_svg.SvgClockMajor;
exports.ClockMinor = icons__ClockMinor_svg.SvgClockMinor;
exports.CodeMajor = icons__CodeMajor_svg.SvgCodeMajor;
exports.CodeMinor = icons__CodeMinor_svg.SvgCodeMinor;
exports.CollectionReferenceMinor = icons__CollectionReferenceMinor_svg.SvgCollectionReferenceMinor;
exports.CollectionsMajor = icons__CollectionsMajor_svg.SvgCollectionsMajor;
exports.ColorNoneMinor = icons__ColorNoneMinor_svg.SvgColorNoneMinor;
exports.ColorsMajor = icons__ColorsMajor_svg.SvgColorsMajor;
exports.Column1Major = icons__Column1Major_svg.SvgColumn1Major;
exports.ColumnWithTextMajor = icons__ColumnWithTextMajor_svg.SvgColumnWithTextMajor;
exports.Columns2Major = icons__Columns2Major_svg.SvgColumns2Major;
exports.Columns3Major = icons__Columns3Major_svg.SvgColumns3Major;
exports.Columns3Minor = icons__Columns3Minor_svg.SvgColumns3Minor;
exports.ComposeMajor = icons__ComposeMajor_svg.SvgComposeMajor;
exports.ConfettiMajor = icons__ConfettiMajor_svg.SvgConfettiMajor;
exports.ConnectMinor = icons__ConnectMinor_svg.SvgConnectMinor;
exports.ContentMinor = icons__ContentMinor_svg.SvgContentMinor;
exports.ConversationMinor = icons__ConversationMinor_svg.SvgConversationMinor;
exports.CreditCardCancelMajor = icons__CreditCardCancelMajor_svg.SvgCreditCardCancelMajor;
exports.CreditCardMajor = icons__CreditCardMajor_svg.SvgCreditCardMajor;
exports.CreditCardPercentMajor = icons__CreditCardPercentMajor_svg.SvgCreditCardPercentMajor;
exports.CreditCardSecureMajor = icons__CreditCardSecureMajor_svg.SvgCreditCardSecureMajor;
exports.CurrencyConvertMinor = icons__CurrencyConvertMinor_svg.SvgCurrencyConvertMinor;
exports.CustomerMinusMajor = icons__CustomerMinusMajor_svg.SvgCustomerMinusMajor;
exports.CustomerPlusMajor = icons__CustomerPlusMajor_svg.SvgCustomerPlusMajor;
exports.CustomersMajor = icons__CustomersMajor_svg.SvgCustomersMajor;
exports.CustomersMinor = icons__CustomersMinor_svg.SvgCustomersMinor;
exports.DataDrivenModelMinor = icons__DataDrivenModelMinor_svg.SvgDataDrivenModelMinor;
exports.DataVisualizationMajor = icons__DataVisualizationMajor_svg.SvgDataVisualizationMajor;
exports.DecimalMinor = icons__DecimalMinor_svg.SvgDecimalMinor;
exports.DeleteMajor = icons__DeleteMajor_svg.SvgDeleteMajor;
exports.DeleteMinor = icons__DeleteMinor_svg.SvgDeleteMinor;
exports.DesktopMajor = icons__DesktopMajor_svg.SvgDesktopMajor;
exports.DetailedPopUpMajor = icons__DetailedPopUpMajor_svg.SvgDetailedPopUpMajor;
exports.DiamondAlertMajor = icons__DiamondAlertMajor_svg.SvgDiamondAlertMajor;
exports.DiamondAlertMinor = icons__DiamondAlertMinor_svg.SvgDiamondAlertMinor;
exports.DigitalMediaReceiverMajor = icons__DigitalMediaReceiverMajor_svg.SvgDigitalMediaReceiverMajor;
exports.DiscountAutomaticMajor = icons__DiscountAutomaticMajor_svg.SvgDiscountAutomaticMajor;
exports.DiscountCodeMajor = icons__DiscountCodeMajor_svg.SvgDiscountCodeMajor;
exports.DiscountsMajor = icons__DiscountsMajor_svg.SvgDiscountsMajor;
exports.DiscountsMinor = icons__DiscountsMinor_svg.SvgDiscountsMinor;
exports.DisputeMinor = icons__DisputeMinor_svg.SvgDisputeMinor;
exports.DnsSettingsMajor = icons__DnsSettingsMajor_svg.SvgDnsSettingsMajor;
exports.DockFloatingMajor = icons__DockFloatingMajor_svg.SvgDockFloatingMajor;
exports.DockSideMajor = icons__DockSideMajor_svg.SvgDockSideMajor;
exports.DomainNewMajor = icons__DomainNewMajor_svg.SvgDomainNewMajor;
exports.DomainRedirectMinor = icons__DomainRedirectMinor_svg.SvgDomainRedirectMinor;
exports.DomainsMajor = icons__DomainsMajor_svg.SvgDomainsMajor;
exports.DraftOrdersMajor = icons__DraftOrdersMajor_svg.SvgDraftOrdersMajor;
exports.DragDropMajor = icons__DragDropMajor_svg.SvgDragDropMajor;
exports.DragHandleMinor = icons__DragHandleMinor_svg.SvgDragHandleMinor;
exports.DropdownMinor = icons__DropdownMinor_svg.SvgDropdownMinor;
exports.DuplicateMinor = icons__DuplicateMinor_svg.SvgDuplicateMinor;
exports.DynamicSourceMajor = icons__DynamicSourceMajor_svg.SvgDynamicSourceMajor;
exports.DynamicSourceMinor = icons__DynamicSourceMinor_svg.SvgDynamicSourceMinor;
exports.EditMajor = icons__EditMajor_svg.SvgEditMajor;
exports.EditMinor = icons__EditMinor_svg.SvgEditMinor;
exports.EmailMajor = icons__EmailMajor_svg.SvgEmailMajor;
exports.EmailNewsletterMajor = icons__EmailNewsletterMajor_svg.SvgEmailNewsletterMajor;
exports.EmbedMinor = icons__EmbedMinor_svg.SvgEmbedMinor;
exports.EnableSelectionMinor = icons__EnableSelectionMinor_svg.SvgEnableSelectionMinor;
exports.EnterMajor = icons__EnterMajor_svg.SvgEnterMajor;
exports.EnvelopeMajor = icons__EnvelopeMajor_svg.SvgEnvelopeMajor;
exports.ExchangeMajor = icons__ExchangeMajor_svg.SvgExchangeMajor;
exports.ExistingInventoryMajor = icons__ExistingInventoryMajor_svg.SvgExistingInventoryMajor;
exports.ExitMajor = icons__ExitMajor_svg.SvgExitMajor;
exports.ExploreImagesMajor = icons__ExploreImagesMajor_svg.SvgExploreImagesMajor;
exports.ExportMinor = icons__ExportMinor_svg.SvgExportMinor;
exports.ExtendMajor = icons__ExtendMajor_svg.SvgExtendMajor;
exports.ExtendMinor = icons__ExtendMinor_svg.SvgExtendMinor;
exports.ExternalMinor = icons__ExternalMinor_svg.SvgExternalMinor;
exports.ExternalSmallMinor = icons__ExternalSmallMinor_svg.SvgExternalSmallMinor;
exports.EyeDropperMinor = icons__EyeDropperMinor_svg.SvgEyeDropperMinor;
exports.FaviconMajor = icons__FaviconMajor_svg.SvgFaviconMajor;
exports.FavoriteMajor = icons__FavoriteMajor_svg.SvgFavoriteMajor;
exports.FeaturedCollectionMajor = icons__FeaturedCollectionMajor_svg.SvgFeaturedCollectionMajor;
exports.FeaturedContentMajor = icons__FeaturedContentMajor_svg.SvgFeaturedContentMajor;
exports.FileMinor = icons__FileMinor_svg.SvgFileMinor;
exports.FilterMajor = icons__FilterMajor_svg.SvgFilterMajor;
exports.FilterMinor = icons__FilterMinor_svg.SvgFilterMinor;
exports.FinancesMajor = icons__FinancesMajor_svg.SvgFinancesMajor;
exports.FinancesMinor = icons__FinancesMinor_svg.SvgFinancesMinor;
exports.FirstClickModelMinor = icons__FirstClickModelMinor_svg.SvgFirstClickModelMinor;
exports.FirstOrderMajor = icons__FirstOrderMajor_svg.SvgFirstOrderMajor;
exports.FirstVisitMajor = icons__FirstVisitMajor_svg.SvgFirstVisitMajor;
exports.FlagMajor = icons__FlagMajor_svg.SvgFlagMajor;
exports.FlipCameraMajor = icons__FlipCameraMajor_svg.SvgFlipCameraMajor;
exports.FolderDownMajor = icons__FolderDownMajor_svg.SvgFolderDownMajor;
exports.FolderMajor = icons__FolderMajor_svg.SvgFolderMajor;
exports.FolderMinusMajor = icons__FolderMinusMajor_svg.SvgFolderMinusMajor;
exports.FolderPlusMajor = icons__FolderPlusMajor_svg.SvgFolderPlusMajor;
exports.FolderUpMajor = icons__FolderUpMajor_svg.SvgFolderUpMajor;
exports.FollowUpEmailMajor = icons__FollowUpEmailMajor_svg.SvgFollowUpEmailMajor;
exports.FoodMajor = icons__FoodMajor_svg.SvgFoodMajor;
exports.FooterMajor = icons__FooterMajor_svg.SvgFooterMajor;
exports.FormsMajor = icons__FormsMajor_svg.SvgFormsMajor;
exports.FraudProtectMajor = icons__FraudProtectMajor_svg.SvgFraudProtectMajor;
exports.FraudProtectMinor = icons__FraudProtectMinor_svg.SvgFraudProtectMinor;
exports.FraudProtectPendingMajor = icons__FraudProtectPendingMajor_svg.SvgFraudProtectPendingMajor;
exports.FraudProtectPendingMinor = icons__FraudProtectPendingMinor_svg.SvgFraudProtectPendingMinor;
exports.FraudProtectUnprotectedMajor = icons__FraudProtectUnprotectedMajor_svg.SvgFraudProtectUnprotectedMajor;
exports.FraudProtectUnprotectedMinor = icons__FraudProtectUnprotectedMinor_svg.SvgFraudProtectUnprotectedMinor;
exports.FulfillmentFulfilledMajor = icons__FulfillmentFulfilledMajor_svg.SvgFulfillmentFulfilledMajor;
exports.FulfillmentOnHoldMajor = icons__FulfillmentOnHoldMajor_svg.SvgFulfillmentOnHoldMajor;
exports.GamesConsoleMajor = icons__GamesConsoleMajor_svg.SvgGamesConsoleMajor;
exports.GiftCardMajor = icons__GiftCardMajor_svg.SvgGiftCardMajor;
exports.GiftCardMinor = icons__GiftCardMinor_svg.SvgGiftCardMinor;
exports.GlobeMajor = icons__GlobeMajor_svg.SvgGlobeMajor;
exports.GlobeMinor = icons__GlobeMinor_svg.SvgGlobeMinor;
exports.GrammarMajor = icons__GrammarMajor_svg.SvgGrammarMajor;
exports.HashtagMajor = icons__HashtagMajor_svg.SvgHashtagMajor;
exports.HashtagMinor = icons__HashtagMinor_svg.SvgHashtagMinor;
exports.HeaderMajor = icons__HeaderMajor_svg.SvgHeaderMajor;
exports.HeartMajor = icons__HeartMajor_svg.SvgHeartMajor;
exports.HideKeyboardMajor = icons__HideKeyboardMajor_svg.SvgHideKeyboardMajor;
exports.HideMinor = icons__HideMinor_svg.SvgHideMinor;
exports.HintMajor = icons__HintMajor_svg.SvgHintMajor;
exports.HomeMajor = icons__HomeMajor_svg.SvgHomeMajor;
exports.HomeMinor = icons__HomeMinor_svg.SvgHomeMinor;
exports.HorizontalDotsMinor = icons__HorizontalDotsMinor_svg.SvgHorizontalDotsMinor;
exports.IconsMajor = icons__IconsMajor_svg.SvgIconsMajor;
exports.IdentityCardMajor = icons__IdentityCardMajor_svg.SvgIdentityCardMajor;
exports.IllustrationMajor = icons__IllustrationMajor_svg.SvgIllustrationMajor;
exports.ImageAltMajor = icons__ImageAltMajor_svg.SvgImageAltMajor;
exports.ImageAltMinor = icons__ImageAltMinor_svg.SvgImageAltMinor;
exports.ImageMajor = icons__ImageMajor_svg.SvgImageMajor;
exports.ImageWithTextMajor = icons__ImageWithTextMajor_svg.SvgImageWithTextMajor;
exports.ImageWithTextOverlayMajor = icons__ImageWithTextOverlayMajor_svg.SvgImageWithTextOverlayMajor;
exports.ImagesMajor = icons__ImagesMajor_svg.SvgImagesMajor;
exports.ImportMinor = icons__ImportMinor_svg.SvgImportMinor;
exports.ImportStoreMajor = icons__ImportStoreMajor_svg.SvgImportStoreMajor;
exports.InactiveLocationMajor = icons__InactiveLocationMajor_svg.SvgInactiveLocationMajor;
exports.InactiveLocationMinor = icons__InactiveLocationMinor_svg.SvgInactiveLocationMinor;
exports.IncomingMajor = icons__IncomingMajor_svg.SvgIncomingMajor;
exports.InfoMinor = icons__InfoMinor_svg.SvgInfoMinor;
exports.InsertDynamicSourceMajor = icons__InsertDynamicSourceMajor_svg.SvgInsertDynamicSourceMajor;
exports.InsertDynamicSourceMinor = icons__InsertDynamicSourceMinor_svg.SvgInsertDynamicSourceMinor;
exports.InstallMinor = icons__InstallMinor_svg.SvgInstallMinor;
exports.InventoryMajor = icons__InventoryMajor_svg.SvgInventoryMajor;
exports.InviteMinor = icons__InviteMinor_svg.SvgInviteMinor;
exports.IqMajor = icons__IqMajor_svg.SvgIqMajor;
exports.JobsMajor = icons__JobsMajor_svg.SvgJobsMajor;
exports.KeyMajor = icons__KeyMajor_svg.SvgKeyMajor;
exports.KeyboardMajor = icons__KeyboardMajor_svg.SvgKeyboardMajor;
exports.KeyboardMinor = icons__KeyboardMinor_svg.SvgKeyboardMinor;
exports.LabelPrinterMajor = icons__LabelPrinterMajor_svg.SvgLabelPrinterMajor;
exports.LandingPageMajor = icons__LandingPageMajor_svg.SvgLandingPageMajor;
exports.LanguageMinor = icons__LanguageMinor_svg.SvgLanguageMinor;
exports.LastClickModelMinor = icons__LastClickModelMinor_svg.SvgLastClickModelMinor;
exports.LastNonDirectClickModelMinor = icons__LastNonDirectClickModelMinor_svg.SvgLastNonDirectClickModelMinor;
exports.LegalMajor = icons__LegalMajor_svg.SvgLegalMajor;
exports.LinearModelMinor = icons__LinearModelMinor_svg.SvgLinearModelMinor;
exports.LinkMinor = icons__LinkMinor_svg.SvgLinkMinor;
exports.ListMajor = icons__ListMajor_svg.SvgListMajor;
exports.ListMinor = icons__ListMinor_svg.SvgListMinor;
exports.LiveViewMajor = icons__LiveViewMajor_svg.SvgLiveViewMajor;
exports.LocationMajor = icons__LocationMajor_svg.SvgLocationMajor;
exports.LocationsMinor = icons__LocationsMinor_svg.SvgLocationsMinor;
exports.LockMajor = icons__LockMajor_svg.SvgLockMajor;
exports.LockMinor = icons__LockMinor_svg.SvgLockMinor;
exports.LogOutMinor = icons__LogOutMinor_svg.SvgLogOutMinor;
exports.LogoBlockMajor = icons__LogoBlockMajor_svg.SvgLogoBlockMajor;
exports.MagicMajor = icons__MagicMajor_svg.SvgMagicMajor;
exports.MagicMinor = icons__MagicMinor_svg.SvgMagicMinor;
exports.ManagedStoreMajor = icons__ManagedStoreMajor_svg.SvgManagedStoreMajor;
exports.MarkFulfilledMinor = icons__MarkFulfilledMinor_svg.SvgMarkFulfilledMinor;
exports.MarkPaidMinor = icons__MarkPaidMinor_svg.SvgMarkPaidMinor;
exports.MarketingMajor = icons__MarketingMajor_svg.SvgMarketingMajor;
exports.MarketingMinor = icons__MarketingMinor_svg.SvgMarketingMinor;
exports.MarketsMajor = icons__MarketsMajor_svg.SvgMarketsMajor;
exports.MaximizeMajor = icons__MaximizeMajor_svg.SvgMaximizeMajor;
exports.MaximizeMinor = icons__MaximizeMinor_svg.SvgMaximizeMinor;
exports.MeasurementMinor = icons__MeasurementMinor_svg.SvgMeasurementMinor;
exports.MentionMajor = icons__MentionMajor_svg.SvgMentionMajor;
exports.MergeMinor = icons__MergeMinor_svg.SvgMergeMinor;
exports.MetafieldsMajor = icons__MetafieldsMajor_svg.SvgMetafieldsMajor;
exports.MetafieldsMinor = icons__MetafieldsMinor_svg.SvgMetafieldsMinor;
exports.MetaobjectMinor = icons__MetaobjectMinor_svg.SvgMetaobjectMinor;
exports.MetaobjectReferenceMinor = icons__MetaobjectReferenceMinor_svg.SvgMetaobjectReferenceMinor;
exports.MicrophoneMajor = icons__MicrophoneMajor_svg.SvgMicrophoneMajor;
exports.MinimizeMajor = icons__MinimizeMajor_svg.SvgMinimizeMajor;
exports.MinimizeMinor = icons__MinimizeMinor_svg.SvgMinimizeMinor;
exports.MinusMajor = icons__MinusMajor_svg.SvgMinusMajor;
exports.MinusMinor = icons__MinusMinor_svg.SvgMinusMinor;
exports.MobileAcceptMajor = icons__MobileAcceptMajor_svg.SvgMobileAcceptMajor;
exports.MobileBackArrowMajor = icons__MobileBackArrowMajor_svg.SvgMobileBackArrowMajor;
exports.MobileCancelMajor = icons__MobileCancelMajor_svg.SvgMobileCancelMajor;
exports.MobileChevronMajor = icons__MobileChevronMajor_svg.SvgMobileChevronMajor;
exports.MobileHamburgerMajor = icons__MobileHamburgerMajor_svg.SvgMobileHamburgerMajor;
exports.MobileHorizontalDotsMajor = icons__MobileHorizontalDotsMajor_svg.SvgMobileHorizontalDotsMajor;
exports.MobileMajor = icons__MobileMajor_svg.SvgMobileMajor;
exports.MobilePlusMajor = icons__MobilePlusMajor_svg.SvgMobilePlusMajor;
exports.MobileVerticalDotsMajor = icons__MobileVerticalDotsMajor_svg.SvgMobileVerticalDotsMajor;
exports.MonerisMajor = icons__MonerisMajor_svg.SvgMonerisMajor;
exports.MoneyMinor = icons__MoneyMinor_svg.SvgMoneyMinor;
exports.NatureMajor = icons__NatureMajor_svg.SvgNatureMajor;
exports.NavigationMajor = icons__NavigationMajor_svg.SvgNavigationMajor;
exports.NoteMajor = icons__NoteMajor_svg.SvgNoteMajor;
exports.NoteMinor = icons__NoteMinor_svg.SvgNoteMinor;
exports.NotificationMajor = icons__NotificationMajor_svg.SvgNotificationMajor;
exports.OnlineStoreMajor = icons__OnlineStoreMajor_svg.SvgOnlineStoreMajor;
exports.OnlineStoreMinor = icons__OnlineStoreMinor_svg.SvgOnlineStoreMinor;
exports.OrderStatusMinor = icons__OrderStatusMinor_svg.SvgOrderStatusMinor;
exports.OrdersMajor = icons__OrdersMajor_svg.SvgOrdersMajor;
exports.OrdersMinor = icons__OrdersMinor_svg.SvgOrdersMinor;
exports.OrganizationMajor = icons__OrganizationMajor_svg.SvgOrganizationMajor;
exports.OutgoingMajor = icons__OutgoingMajor_svg.SvgOutgoingMajor;
exports.PackageMajor = icons__PackageMajor_svg.SvgPackageMajor;
exports.PageDownMajor = icons__PageDownMajor_svg.SvgPageDownMajor;
exports.PageMajor = icons__PageMajor_svg.SvgPageMajor;
exports.PageMinusMajor = icons__PageMinusMajor_svg.SvgPageMinusMajor;
exports.PagePlusMajor = icons__PagePlusMajor_svg.SvgPagePlusMajor;
exports.PageReferenceMinor = icons__PageReferenceMinor_svg.SvgPageReferenceMinor;
exports.PageUpMajor = icons__PageUpMajor_svg.SvgPageUpMajor;
exports.PaginationEndMinor = icons__PaginationEndMinor_svg.SvgPaginationEndMinor;
exports.PaginationStartMinor = icons__PaginationStartMinor_svg.SvgPaginationStartMinor;
exports.PaintBrushMajor = icons__PaintBrushMajor_svg.SvgPaintBrushMajor;
exports.PaperCheckMajor = icons__PaperCheckMajor_svg.SvgPaperCheckMajor;
exports.PaperCheckMinor = icons__PaperCheckMinor_svg.SvgPaperCheckMinor;
exports.PasskeyMajor = icons__PasskeyMajor_svg.SvgPasskeyMajor;
exports.PasskeyMinor = icons__PasskeyMinor_svg.SvgPasskeyMinor;
exports.PauseCircleMajor = icons__PauseCircleMajor_svg.SvgPauseCircleMajor;
exports.PauseMajor = icons__PauseMajor_svg.SvgPauseMajor;
exports.PauseMinor = icons__PauseMinor_svg.SvgPauseMinor;
exports.PaymentsMajor = icons__PaymentsMajor_svg.SvgPaymentsMajor;
exports.PersonalizedTextMajor = icons__PersonalizedTextMajor_svg.SvgPersonalizedTextMajor;
exports.PhoneInMajor = icons__PhoneInMajor_svg.SvgPhoneInMajor;
exports.PhoneMajor = icons__PhoneMajor_svg.SvgPhoneMajor;
exports.PhoneOutMajor = icons__PhoneOutMajor_svg.SvgPhoneOutMajor;
exports.PinMajor = icons__PinMajor_svg.SvgPinMajor;
exports.PinMinor = icons__PinMinor_svg.SvgPinMinor;
exports.PinUnfilledMajor = icons__PinUnfilledMajor_svg.SvgPinUnfilledMajor;
exports.PinUnfilledMinor = icons__PinUnfilledMinor_svg.SvgPinUnfilledMinor;
exports.PlanMajor = icons__PlanMajor_svg.SvgPlanMajor;
exports.PlanMinor = icons__PlanMinor_svg.SvgPlanMinor;
exports.PlayCircleMajor = icons__PlayCircleMajor_svg.SvgPlayCircleMajor;
exports.PlayMajor = icons__PlayMajor_svg.SvgPlayMajor;
exports.PlayMinor = icons__PlayMinor_svg.SvgPlayMinor;
exports.PlusMinor = icons__PlusMinor_svg.SvgPlusMinor;
exports.PointOfSaleMajor = icons__PointOfSaleMajor_svg.SvgPointOfSaleMajor;
exports.PopularMajor = icons__PopularMajor_svg.SvgPopularMajor;
exports.PositionBasedModelMinor = icons__PositionBasedModelMinor_svg.SvgPositionBasedModelMinor;
exports.PriceLookupMinor = icons__PriceLookupMinor_svg.SvgPriceLookupMinor;
exports.PrintMajor = icons__PrintMajor_svg.SvgPrintMajor;
exports.PrintMinor = icons__PrintMinor_svg.SvgPrintMinor;
exports.ProductCostMajor = icons__ProductCostMajor_svg.SvgProductCostMajor;
exports.ProductReferenceMinor = icons__ProductReferenceMinor_svg.SvgProductReferenceMinor;
exports.ProductReturnsMinor = icons__ProductReturnsMinor_svg.SvgProductReturnsMinor;
exports.ProductsMajor = icons__ProductsMajor_svg.SvgProductsMajor;
exports.ProductsMinor = icons__ProductsMinor_svg.SvgProductsMinor;
exports.ProfileMajor = icons__ProfileMajor_svg.SvgProfileMajor;
exports.ProfileMinor = icons__ProfileMinor_svg.SvgProfileMinor;
exports.PromoteMinor = icons__PromoteMinor_svg.SvgPromoteMinor;
exports.QuestionMarkInverseMajor = icons__QuestionMarkInverseMajor_svg.SvgQuestionMarkInverseMajor;
exports.QuestionMarkInverseMinor = icons__QuestionMarkInverseMinor_svg.SvgQuestionMarkInverseMinor;
exports.QuestionMarkMajor = icons__QuestionMarkMajor_svg.SvgQuestionMarkMajor;
exports.QuestionMarkMinor = icons__QuestionMarkMinor_svg.SvgQuestionMarkMinor;
exports.QuickSaleMajor = icons__QuickSaleMajor_svg.SvgQuickSaleMajor;
exports.ReadTimeMinor = icons__ReadTimeMinor_svg.SvgReadTimeMinor;
exports.ReceiptMajor = icons__ReceiptMajor_svg.SvgReceiptMajor;
exports.RecentSearchesMajor = icons__RecentSearchesMajor_svg.SvgRecentSearchesMajor;
exports.RedoMajor = icons__RedoMajor_svg.SvgRedoMajor;
exports.ReferralCodeMajor = icons__ReferralCodeMajor_svg.SvgReferralCodeMajor;
exports.ReferralMajor = icons__ReferralMajor_svg.SvgReferralMajor;
exports.RefreshMajor = icons__RefreshMajor_svg.SvgRefreshMajor;
exports.RefreshMinor = icons__RefreshMinor_svg.SvgRefreshMinor;
exports.RefundMajor = icons__RefundMajor_svg.SvgRefundMajor;
exports.RefundMinor = icons__RefundMinor_svg.SvgRefundMinor;
exports.RemoveProductMajor = icons__RemoveProductMajor_svg.SvgRemoveProductMajor;
exports.RepeatOrderMajor = icons__RepeatOrderMajor_svg.SvgRepeatOrderMajor;
exports.ReplaceMajor = icons__ReplaceMajor_svg.SvgReplaceMajor;
exports.ReplayMinor = icons__ReplayMinor_svg.SvgReplayMinor;
exports.ReportMinor = icons__ReportMinor_svg.SvgReportMinor;
exports.ReportsMajor = icons__ReportsMajor_svg.SvgReportsMajor;
exports.ResetMinor = icons__ResetMinor_svg.SvgResetMinor;
exports.ResourcesMajor = icons__ResourcesMajor_svg.SvgResourcesMajor;
exports.ReturnMinor = icons__ReturnMinor_svg.SvgReturnMinor;
exports.ReturnsMajor = icons__ReturnsMajor_svg.SvgReturnsMajor;
exports.RichTextMinor = icons__RichTextMinor_svg.SvgRichTextMinor;
exports.RiskMajor = icons__RiskMajor_svg.SvgRiskMajor;
exports.RiskMinor = icons__RiskMinor_svg.SvgRiskMinor;
exports.Rows2Major = icons__Rows2Major_svg.SvgRows2Major;
exports.SandboxMajor = icons__SandboxMajor_svg.SvgSandboxMajor;
exports.SaveMinor = icons__SaveMinor_svg.SvgSaveMinor;
exports.SearchMajor = icons__SearchMajor_svg.SvgSearchMajor;
exports.SearchMinor = icons__SearchMinor_svg.SvgSearchMinor;
exports.SectionMajor = icons__SectionMajor_svg.SvgSectionMajor;
exports.SecureMajor = icons__SecureMajor_svg.SvgSecureMajor;
exports.SelectMinor = icons__SelectMinor_svg.SvgSelectMinor;
exports.SendMajor = icons__SendMajor_svg.SvgSendMajor;
exports.SettingsMajor = icons__SettingsMajor_svg.SvgSettingsMajor;
exports.SettingsMinor = icons__SettingsMinor_svg.SvgSettingsMinor;
exports.ShareIosMinor = icons__ShareIosMinor_svg.SvgShareIosMinor;
exports.ShareMinor = icons__ShareMinor_svg.SvgShareMinor;
exports.ShipmentMajor = icons__ShipmentMajor_svg.SvgShipmentMajor;
exports.ShopcodesMajor = icons__ShopcodesMajor_svg.SvgShopcodesMajor;
exports.SidebarLeftMajor = icons__SidebarLeftMajor_svg.SvgSidebarLeftMajor;
exports.SidebarRightMajor = icons__SidebarRightMajor_svg.SvgSidebarRightMajor;
exports.SimplifyMajor = icons__SimplifyMajor_svg.SvgSimplifyMajor;
exports.SimplifyMinor = icons__SimplifyMinor_svg.SvgSimplifyMinor;
exports.SlideshowMajor = icons__SlideshowMajor_svg.SvgSlideshowMajor;
exports.SmileyHappyMajor = icons__SmileyHappyMajor_svg.SvgSmileyHappyMajor;
exports.SmileyJoyMajor = icons__SmileyJoyMajor_svg.SvgSmileyJoyMajor;
exports.SmileyNeutralMajor = icons__SmileyNeutralMajor_svg.SvgSmileyNeutralMajor;
exports.SmileySadMajor = icons__SmileySadMajor_svg.SvgSmileySadMajor;
exports.SocialAdMajor = icons__SocialAdMajor_svg.SvgSocialAdMajor;
exports.SocialPostMajor = icons__SocialPostMajor_svg.SvgSocialPostMajor;
exports.SoftPackMajor = icons__SoftPackMajor_svg.SvgSoftPackMajor;
exports.SortAscendingMajor = icons__SortAscendingMajor_svg.SvgSortAscendingMajor;
exports.SortDescendingMajor = icons__SortDescendingMajor_svg.SvgSortDescendingMajor;
exports.SortMinor = icons__SortMinor_svg.SvgSortMinor;
exports.SoundMajor = icons__SoundMajor_svg.SvgSoundMajor;
exports.StarFilledMinor = icons__StarFilledMinor_svg.SvgStarFilledMinor;
exports.StarOutlineMinor = icons__StarOutlineMinor_svg.SvgStarOutlineMinor;
exports.StatusActiveMajor = icons__StatusActiveMajor_svg.SvgStatusActiveMajor;
exports.StoreMajor = icons__StoreMajor_svg.SvgStoreMajor;
exports.StoreMinor = icons__StoreMinor_svg.SvgStoreMinor;
exports.StoreStatusMajor = icons__StoreStatusMajor_svg.SvgStoreStatusMajor;
exports.TabletMajor = icons__TabletMajor_svg.SvgTabletMajor;
exports.TapChipMajor = icons__TapChipMajor_svg.SvgTapChipMajor;
exports.TaxMajor = icons__TaxMajor_svg.SvgTaxMajor;
exports.TeamMajor = icons__TeamMajor_svg.SvgTeamMajor;
exports.TemplateMajor = icons__TemplateMajor_svg.SvgTemplateMajor;
exports.TemplateMinor = icons__TemplateMinor_svg.SvgTemplateMinor;
exports.TextAlignmentCenterMajor = icons__TextAlignmentCenterMajor_svg.SvgTextAlignmentCenterMajor;
exports.TextAlignmentLeftMajor = icons__TextAlignmentLeftMajor_svg.SvgTextAlignmentLeftMajor;
exports.TextAlignmentRightMajor = icons__TextAlignmentRightMajor_svg.SvgTextAlignmentRightMajor;
exports.TextBlockMajor = icons__TextBlockMajor_svg.SvgTextBlockMajor;
exports.TextMajor = icons__TextMajor_svg.SvgTextMajor;
exports.ThemeEditMajor = icons__ThemeEditMajor_svg.SvgThemeEditMajor;
exports.ThemeStoreMajor = icons__ThemeStoreMajor_svg.SvgThemeStoreMajor;
exports.ThemesMajor = icons__ThemesMajor_svg.SvgThemesMajor;
exports.ThumbsDownMajor = icons__ThumbsDownMajor_svg.SvgThumbsDownMajor;
exports.ThumbsDownMinor = icons__ThumbsDownMinor_svg.SvgThumbsDownMinor;
exports.ThumbsUpMajor = icons__ThumbsUpMajor_svg.SvgThumbsUpMajor;
exports.ThumbsUpMinor = icons__ThumbsUpMinor_svg.SvgThumbsUpMinor;
exports.TickMinor = icons__TickMinor_svg.SvgTickMinor;
exports.TickSmallMinor = icons__TickSmallMinor_svg.SvgTickSmallMinor;
exports.TimeDecayModelMinor = icons__TimeDecayModelMinor_svg.SvgTimeDecayModelMinor;
exports.TimelineAttachmentMajor = icons__TimelineAttachmentMajor_svg.SvgTimelineAttachmentMajor;
exports.TipsMajor = icons__TipsMajor_svg.SvgTipsMajor;
exports.TitleMinor = icons__TitleMinor_svg.SvgTitleMinor;
exports.ToggleMinor = icons__ToggleMinor_svg.SvgToggleMinor;
exports.ToolsMajor = icons__ToolsMajor_svg.SvgToolsMajor;
exports.TransactionFeeDollarMajor = icons__TransactionFeeDollarMajor_svg.SvgTransactionFeeDollarMajor;
exports.TransactionFeeEuroMajor = icons__TransactionFeeEuroMajor_svg.SvgTransactionFeeEuroMajor;
exports.TransactionFeePoundMajor = icons__TransactionFeePoundMajor_svg.SvgTransactionFeePoundMajor;
exports.TransactionFeeRupeeMajor = icons__TransactionFeeRupeeMajor_svg.SvgTransactionFeeRupeeMajor;
exports.TransactionFeeYenMajor = icons__TransactionFeeYenMajor_svg.SvgTransactionFeeYenMajor;
exports.TransactionMajor = icons__TransactionMajor_svg.SvgTransactionMajor;
exports.TransferInMajor = icons__TransferInMajor_svg.SvgTransferInMajor;
exports.TransferMajor = icons__TransferMajor_svg.SvgTransferMajor;
exports.TransferOutMajor = icons__TransferOutMajor_svg.SvgTransferOutMajor;
exports.TransferWithinShopifyMajor = icons__TransferWithinShopifyMajor_svg.SvgTransferWithinShopifyMajor;
exports.TransportMajor = icons__TransportMajor_svg.SvgTransportMajor;
exports.TroubleshootMajor = icons__TroubleshootMajor_svg.SvgTroubleshootMajor;
exports.TypeMajor = icons__TypeMajor_svg.SvgTypeMajor;
exports.TypeMinor = icons__TypeMinor_svg.SvgTypeMinor;
exports.UndoMajor = icons__UndoMajor_svg.SvgUndoMajor;
exports.UnfulfilledMajor = icons__UnfulfilledMajor_svg.SvgUnfulfilledMajor;
exports.UnknownDeviceMajor = icons__UnknownDeviceMajor_svg.SvgUnknownDeviceMajor;
exports.UpdateInventoryMajor = icons__UpdateInventoryMajor_svg.SvgUpdateInventoryMajor;
exports.UploadMajor = icons__UploadMajor_svg.SvgUploadMajor;
exports.VariantMajor = icons__VariantMajor_svg.SvgVariantMajor;
exports.ViewMajor = icons__ViewMajor_svg.SvgViewMajor;
exports.ViewMinor = icons__ViewMinor_svg.SvgViewMinor;
exports.ViewportNarrowMajor = icons__ViewportNarrowMajor_svg.SvgViewportNarrowMajor;
exports.ViewportShortMajor = icons__ViewportShortMajor_svg.SvgViewportShortMajor;
exports.ViewportTallMajor = icons__ViewportTallMajor_svg.SvgViewportTallMajor;
exports.ViewportWideMajor = icons__ViewportWideMajor_svg.SvgViewportWideMajor;
exports.VocabularyMajor = icons__VocabularyMajor_svg.SvgVocabularyMajor;
exports.VolumeMinor = icons__VolumeMinor_svg.SvgVolumeMinor;
exports.WandMajor = icons__WandMajor_svg.SvgWandMajor;
exports.WandMinor = icons__WandMinor_svg.SvgWandMinor;
exports.WearableMajor = icons__WearableMajor_svg.SvgWearableMajor;
exports.WeightMinor = icons__WeightMinor_svg.SvgWeightMinor;
exports.WholesaleMajor = icons__WholesaleMajor_svg.SvgWholesaleMajor;
exports.WifiMajor = icons__WifiMajor_svg.SvgWifiMajor;
